import { usePrivy } from '@privy-io/react-auth';
import NavUserProfile from '../../../components/NavUserProfile';
import styled from 'styled-components';
import WidthContainer from '../../../components/WidthContainer';
import { Capacitor } from '@capacitor/core';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';

const NavbarOutContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.border.dashed};
`;

const NavbarContainer = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media ${PHONE_MEDIA_QUERY} {
    height: 60px;
    ${() =>
      Capacitor.isNativePlatform() &&
      `
        height: 60px;
      `}
  }
`;

export const VETS_PATHS = [
  'wallet',
  'deposit',
  'usd',
  'vets/buy',
  'vets/sell',
  'vets/sell/confirm',
  'vets/buy/confirm',
  'app/swap',
  'vets/deposit-selection',
  'vets/withdraw-selection',
  'vets/withdraw-crypto',
  'vets/deposit-crypto',
  '^vets$',
];

const Navbar = () => {
  const { user } = usePrivy();

  return (
    <NavbarOutContainer>
      <WidthContainer>
        <NavbarContainer>
          <NavUserProfile user={user} />
        </NavbarContainer>
      </WidthContainer>
    </NavbarOutContainer>
  );
};

export default Navbar;
